import { Component, ElementRef } from '@angular/core';

import { Directionality } from '@angular/cdk/bidi';

@Component({
  selector: 'visitoragreements',
  templateUrl: './visitoragreements.component.html',
  styleUrl: './visitoragreements.component.scss',
  standalone: !true
})
export class VisitorAgreementsComponent {

	currentDirection: any;

	constructor(private directionality: Directionality, private elementRef: ElementRef) {
		this.currentDirection = this.directionality.value;
	}

	
}
